import { SDKOptions, SportTypes } from '../../types';
import { generateRequest } from '../http.service';

export interface IStandingsProps {
  stage_id?: string;
  coverageType?: string;
  groupId?: string;
  filter?: string;
  homeAway?: string;
  sport?: SportTypes;
}

export const getStandings = async ({
  params,
  sdkOptions,
  sport,
}: {
  params: IStandingsProps;
  sdkOptions: SDKOptions;
  sport: SportTypes;
}) => {
  const url = `${sdkOptions.dataConfigStandingsApiUrl}/standings/${sport}?translation_language=${sdkOptions.dataConfigLang}&optional_data=FORM`;

  const baseParams = {
    ...params,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
